const state = () => ({
	notices: [],
	secretQuestions: []
});

const getters = {
	getNotices: (state) => state.notices,
	getNoticesPerId: (state) => (id) => {
		const noticesPerId = [];
		for (let i = 0; i < state.notices.length; i++) {
			if (state.notices[i].id === id) {
				noticesPerId.push(state.notices[i]);
			}
		}
		return noticesPerId;
	},
	getSQ: (state) => state.secretQuestions,
	getSQPerId: (state) => (id) => {
		const secretQuestionsPerId = [];
		for (let i = 0; i < state.secretQuestions.length; i++) {
			if (state.secretQuestions[i].id === id) {
				secretQuestionsPerId.push(state.secretQuestions[i]);
			}
		}
		return secretQuestionsPerId;
	}
};

const mutations = {
	setNotices (state, notices) {
		state.notices = notices;
	},
	addNotices (state, newNotices) {
		state.notices.push(newNotices);
	},
	setSQ (state, secretQuestions) {
		state.secretQuestions = secretQuestions;
	},
	addSQ (state, newSecretQuestions) {
		state.secretQuestions.push(newSecretQuestions);
	}
};

const actions = {};

export default {
	state,
	getters,
	actions,
	mutations
};
